import EditCalendarItemScreen from './EditCalendarItemScreen';

export default EditCalendarItemScreen;
